module.exports = function(app) {
    app.directive('myChartEspot', ['$rootScope', 'coremetrics', 'myChartUtil', 'sessionData', 'brand', 
        function($rootScope, coremetrics, myChartUtil, sessionData, brand) {
            return {
                    restrict: 'A',
                    template: "<button data-ng-click='goToMyChart()' data-ng-if='showMyChartEspot'>" +
                        "<img src='/content/dam/generic/en/healthco/images/claims/myChart_espot.png' alt='My Chart' />" +
                    "</button>",
                scope: {},
                link: function(scope) {
                    scope.goToMyChart = function() {
                        coremetrics.elementTag('GO TO MYCHART', 'MEMBER:CLAIMS');
                        window.open("/my-chart/#/home", "_self");
                    };

                    $rootScope.$on('updateMyChartVisibility', function(data, summary){
                        scope.showMyChartEspot = myChartUtil.hasEligibleClaims(summary) &&
                            brand.current.sharedBrandCode.toLowerCase() == 'hmbcbs';
                    });
                }
            };
        }
    ]);
};